import { createContext, useContext } from "react"

import { AppliedScheme, DocumentThemeMode, ScannedArea } from "../types/local"

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error("useTheme must be used within a <ThemeProvider/>")
  }
  return context
}

interface ContextValue {
  scannedArea?: ScannedArea
  uiScheme: AppliedScheme
  setUIScheme: (scheme: AppliedScheme) => void
  setScannedArea: (scannedArea: ScannedArea) => void
  documentThemeMode: DocumentThemeMode
  setDocumentThemeMode: (mode: DocumentThemeMode) => void
}

export const ThemeContext = createContext<ContextValue | undefined>(undefined)
